<template>
  <div class="fanzhou-page">
    <div class="button" @click="downloadAction" data-sensors-click>立即领取额度 <img src="./images/arrow.png" alt=""></div>
    <DownloadQuestion :config="jumpPosition"/>
    <ios-download v-model="downloadVisible"></ios-download>
  </div>
</template>

<script>
import jumpMixins from '@/view/landing/jumpMixins.js'
import IosDownload from '@/components/ios-download'
import DownloadQuestion from '@/view/landing/components/downloadQuestion.vue'
export default {
  components: { IosDownload, DownloadQuestion },
  name: 'FanZhouLanding',
  mixins: [jumpMixins],
  data () {
    return {
      downloadVisible: false,
      questionDialog: false
    }
  },
  methods: {
 
    copyAndroidDownloadLink () {
      this.copyUrlAndToast()
      this.questionDialog = false
    },
    downloadAction () {
      this.$emit('handleDownload')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

@keyframes scaleAnimation {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}

.question-dialog {
  /deep/.default-content {
    padding-top: 0;
  }

  .question {
    background-image: url(./images/img_question_pop.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    width: 620px;
    height: 650px;
    padding-top: 505px;

    .copy-btn {
      width: 440px;
      height: 80px;
      background: linear-gradient(90deg, #FF7831 0%, #FFC994 100%);
      box-shadow: 0px 14px 20px 4px #E8EDFF;
      border-radius: 40px;
      font-size: 36px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 80px;
      text-align: center;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 40px;
        height: 40px;
      }

      span {
        padding-left: 10px;
      }
    }
  }
}

.fanzhou-page {
  height: 2276px;
  background-image: url("./images/bg.png");
  background-position: top center;
  background-repeat: no-repeat;
  background-color: #444d87;
  background-size: 100%;
  padding-top: 1px;
}

.button {
  width: 570px;
  height: 94px;
  line-height: 94px;
  background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
  text-align: center;
  font-size: 36px;
  color: #ffffff;
  border-radius: 60px;
  box-shadow: 0px 7px 20px 0px rgba(226, 48, 48, 0.15);
  margin: 1000px auto 0;
  font-weight: bold;
  animation: scaleAnimation 1s linear infinite;

  img {
    width: 11px;
  }
}

.qa {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff4633;
  line-height: 33px;

  img {
    width: 24px;
    height: 24px;
    margin-left: 10px;
  }

  margin-top: 20px;
}
</style>